export const BASE_URL =
  typeof window !== "undefined"
    ? `${window.location.origin}/dashboard`
    : "http://localhost:3000/dashboard";
